import { useState } from "react";
import { similarItems, similarTags } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function SimilarSection() {
  const [active, setActive] = useState("全部");

  const filtered =
    active === "全部" ? similarItems : similarItems.filter((item) => item.tags.includes(active));

  return (
    <section id="similar" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="找同款"
          title="按题材标签，筛出相似方向的衍生作品"
          desc="如果你喜欢的是某一种感觉，而不是某一部作品，可以先勾选题材标签，把同方向的条目筛出来，再逐条判断是否对味。"
        />

        <div className="mt-8 flex flex-wrap gap-2" role="group" aria-label="题材标签筛选">
          {similarTags.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => setActive(tag)}
              aria-pressed={active === tag}
              className={`px-4 py-2 text-sm rounded-full border whitespace-nowrap transition-colors ${
                active === tag
                  ? "bg-primary-500 text-background-50 border-primary-500"
                  : "bg-background-50 text-foreground-700 border-background-300 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {tag}
            </button>
          ))}
        </div>

        <p className="mt-4 text-sm text-foreground-500">
          当前筛选：<span className="text-primary-600 font-medium">{active}</span> · 共 {filtered.length} 条方向
        </p>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {filtered.map((item) => (
            <article
              key={item.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-900 text-xl">
                  <i className={item.icon}></i>
                </span>
                <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-xs">
                  <i className="ri-sparkling-line"></i>
                  匹配度 {item.match}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">{item.desc}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-2.5 py-1 text-xs rounded-full bg-primary-50 text-primary-700 border border-primary-200 whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="mt-6 rounded-lg border border-dashed border-background-300 bg-background-50 py-12 text-center">
            <p className="text-sm text-foreground-500">该标签下暂无条目，换一个试试。</p>
          </div>
        )}
      </div>
    </section>
  );
}